import api from './utilBackoffice';

const controller = 'ListRestrCadoc';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => api.Axios.GetParams(url, dto),
  Create: dto => api.Axios.Post(url, dto),
  Upload: dto => api.Axios.Post(url + '/Upload', dto),
  Update: dto => api.Axios.PutCommand(url, dto),
  Delete: dto => api.Axios.DeleteCommand(url, dto)
});
